import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import { jsxs, jsx } from 'react/jsx-runtime';
import { Text, Spacing, Divider } from '@dls/web';
import { Fragment } from 'react';
import styled from 'styled-components';
import '../../../../../../StyleComponents/SCContainerStyledComponent.js';
import '../../../../../../StyleComponents/SCDivStyledComponents.js';
import { SCTextStyledComponent } from '../../../../../../StyleComponents/SCTextStyledComponent.js';
import { TextTruncate } from '../../../../../../StyleComponents/style.js';
import { SCAnchorBlack } from '../../EmpowerHeader/DesktopMenu/styles.js';
const MobilePublicSubMenu = _ref => {
  let {
    isOpen,
    parentMenuTitle,
    menuItems
  } = _ref;
  return /* @__PURE__ */jsxs(MobileSubMenuContainer, {
    isOpen,
    children: [/* @__PURE__ */jsx(Text, {
      type: "header",
      tag: "div",
      children: parentMenuTitle
    }), menuItems == null ? void 0 : menuItems.filter(item => item.item.active).map((menuGroup, index) => {
      return /* @__PURE__ */jsxs(Fragment, {
        children: [index === 0 ? null : /* @__PURE__ */jsx(Spacing, {
          top: 2,
          bottom: 1,
          children: /* @__PURE__ */jsx(Divider, {})
        }), /* @__PURE__ */jsx(Spacing, {
          top: 2.5,
          children: menuGroup.item.href ? /* @__PURE__ */jsx(SCAnchorBlack, {
            href: menuGroup.item.href,
            children: /* @__PURE__ */jsx(SCTextStyledComponent, {
              css: TextTruncate,
              type: "smallBody",
              fontWeight: "bold",
              children: menuGroup.item.title
            })
          }) : /* @__PURE__ */jsx(SCTextStyledComponent, {
            css: TextTruncate,
            type: "smallBody",
            fontWeight: "bold",
            children: menuGroup.item.title
          })
        }), menuGroup.subMenu && menuGroup.subMenu.filter(item => item.item.active).map((subMenuItem, subIndex) => {
          return /* @__PURE__ */jsx(Spacing, {
            topBottom: 1,
            children: /* @__PURE__ */jsx(SCAnchorBlack, {
              href: subMenuItem.item.href,
              children: /* @__PURE__ */jsx(SCTextStyledComponent, {
                css: TextTruncate,
                type: "smallBody",
                children: subMenuItem.item.title
              })
            }, subIndex)
          });
        })]
      }, index);
    })]
  });
};
const MobileSubMenuContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-top: 0.5rem;\n  transition: opacity 400ms ease-out;\n  opacity: ", ";\n"])), props => props.isOpen ? 1 : 0);
export { MobilePublicSubMenu as default };